<div class="{{ 'MuiPaper-root MuiAlert-root  MuiPaper-elevation6 ' + color }}">
  <div class="MuiAlert-icon" *ngIf="icon">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="MuiAlert-message" *ngIf="message">
    {{ message }}
  </div>
</div>
